import { render, staticRenderFns } from "./addwuliao.vue?vue&type=template&id=b0cd58b6"
import script from "./addwuliao.vue?vue&type=script&lang=js"
export * from "./addwuliao.vue?vue&type=script&lang=js"
import style0 from "./addwuliao.vue?vue&type=style&index=0&id=b0cd58b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports